import { render, staticRenderFns } from "./purchase_hangqingDetail.vue?vue&type=template&id=70e613c4&scoped=true"
import script from "./purchase_hangqingDetail.vue?vue&type=script&lang=js"
export * from "./purchase_hangqingDetail.vue?vue&type=script&lang=js"
import style0 from "./purchase_hangqingDetail.vue?vue&type=style&index=0&id=70e613c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e613c4",
  null
  
)

export default component.exports